import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS, DEFAULT_LANG, type LangCode } from "@/constants/site";

export function useLanguage(lang?: string): LangCode {
  const { i18n } = useTranslation();

  const current: LangCode = lang && (SUPPORTED_LANGS as readonly string[]).includes(lang)
    ? (lang as LangCode)
    : DEFAULT_LANG;

  useEffect(() => {
    if (i18n.language !== current) {
      i18n.changeLanguage(current);
    }
    document.documentElement.lang = current;
  }, [current, i18n]);

  return current;
}